import React, { useEffect, useState } from "react";
import { Header, Sidebar } from "../Layout";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { EMAIL_TEMPLATE_LIST } from '../../../constants/constants';
import { createEmailTemplate, updateEmailTemplate, getEmailTemplateByType } from "../../../actions/emailTemplateActions";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const CreateEmailTemplate = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [paramId, setParamId] = useState("");
    const [template, setTemplate] = useState({});
    const [inputSubject, setInputSubject] = useState();

    const [options, setOptions] = useState();
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    useEffect(() => {
        setOptions(EMAIL_TEMPLATE_LIST)
        const queryParams = new URLSearchParams(window.location.search)
        const type = queryParams.get("type")
        setParamId(type);
        if (type) {
            async function fetchData() {
                // You can await here
                const response = await getEmailTemplateByType(type);
                setTemplate(response?.data?.data.content);
                setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(response.data.data.content))))
                setInputSubject(response?.data?.data.subject)
                formik.setFieldValue("subject", response?.data?.data.subject);
                formik.setFieldValue("type", type);
            }
            fetchData();
        }
    }, [])

    const formik = useFormik({
        initialValues: {
            type: template.email_type,
            subject: template.subject,
            body: template.content,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            type: Yup.string(),
            subject: Yup.string().required('Subject is requied'),
            body: Yup.string().required('Body is required'),
        }),
        onSubmit: (value, { resetForm }) => {
            const template = {
                email_type: paramId,
                subject: value.subject,
                content: value.body,
            };

            if (paramId) {
                template.email_type = paramId;
                dispatch(updateEmailTemplate(template, history));
            }
            else dispatch(createEmailTemplate(template, history));
            resetForm();
        },
    });
    const getEmailContentOnType = async (event) => {
        console.log(event.target.value)
        setParamId(event.target.value)
        let temp = await getEmailTemplateByType(event.target.value)
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(temp.data.data.content))))
        setTemplate(temp.data.data.content);
    }
    useEffect(() => {
        const blocksFromHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        formik.setFieldValue("body", blocksFromHTML);
    }, [editorState]);

    return (<>
        <Header />
        <Sidebar />
        <div id="main-content">
            <div className="row clearfix justify-content-center w-100 p-3">
                <div className="col-lg-8 col-md-8 col-sm-8">
                    <div className="card">
                        <div className="header custum-bg-warning rounded">
                            <h2 className="text-white">{paramId ? 'Update' : 'Create'} Email Template</h2>
                        </div>
                        <div className="body card-body-shadow">
                            <form className="form-auth-small" onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Type<span className='text-danger'>*</span></label>
                                            <select name="type" id="type"  {...formik.getFieldProps('type')} onChange={getEmailContentOnType} className="form-control">
                                                {options && options.map((option, index) => {
                                                    return <option key={index}>{option}</option>
                                                })}
                                            </select>
                                            {formik.touched.type && formik.errors.type ? (
                                                <div className="text-danger">{formik.errors.type}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Subject<span className='text-danger'>*</span></label>
                                            <input type="text" placeholder="Please Enter Subject" className="form-control" name="subject" defaultValue={inputSubject} id="subject" {...formik.getFieldProps('subject')} required />
                                            {formik.touched.subject && formik.errors.subject ? (
                                                <div className="text-danger">{formik.errors.subject}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Body<span className='text-danger'>*</span></label>
                                            <Editor
                                                editorState={editorState}
                                                onEditorStateChange={setEditorState}
                                            />
                                            {formik.touched.body && formik.errors.body ? (
                                                <div className="text-danger">{formik.errors.body}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row text-right ml-5">
                                    <div className='col-md-6 col-lg-6 col-sm-6'>
                                        <button type="submit" className='btn button text-white'>{paramId ? 'Update Template' : 'Save Template'}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default CreateEmailTemplate;